/**
 * 404 Not Found Page
 *
 * Rendered by the catch-all route so unknown URLs return a real page
 * (with noindex) instead of a soft-200 blank screen.
 */

import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import SEO from '../components/common/SEO'
import PageHero from '../components/common/PageHero'

const NotFound = () => {
  return (
    <>
      <SEO title="Page Not Found" path="/404" noIndex />

      <PageHero
        title="Page Not Found"
        subtitle="404"
        size="md"
        texture="warm-linen"
      />

      <section className="bg-cream-200 py-20 md:py-28">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <motion.p
            className="font-sans text-dark-500 text-base md:text-lg leading-relaxed mb-8"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
          >
            The page you&apos;re looking for doesn&apos;t exist or may have
            moved. Let&apos;s get you back on track.
          </motion.p>

          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-block bg-brand-orange-500 text-white px-6 py-3 font-sans text-xs tracking-[0.15em] uppercase
                         hover:bg-brand-orange-400 transition-colors duration-200"
            >
              Back Home
            </Link>
            <Link
              to="/services"
              className="inline-block border border-dark-700 text-dark-700 px-6 py-3 font-sans text-xs tracking-[0.15em] uppercase
                         hover:bg-dark-700 hover:text-white transition-all duration-200"
            >
              View Services
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}

export default NotFound
